import { FC, useEffect, useState } from "react";
import styles from "./Dropdown.module.scss";
import { IDropdownList } from "./Dropdown";
import { DropdownOption } from "./MultiDropdown";
import arrow from "../../../images/icons/arrow.svg";

// Другая тема
export const DropdownTwo: FC<IDropdownList> = ({
  data,
  state,
  setState,
  name,
  placeholder = "Select value",
  required = false,
}) => {
  const handlerClick = (item: DropdownOption) => {
    if (data.length === 0) return;
    setState(item.id);
    setIsOpen(false);
  };

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleBlur = (event: React.FocusEvent<HTMLDivElement>) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setIsOpen(false);
    }
  };

  return (
    <div
      className={`${styles.multidropdown} ${name && styles.mt_30}`}
      onBlur={handleBlur}
      tabIndex={0}
    >
      <label className={styles.dropdownLabel}>
        {name} {required && <span className={styles.required}> *</span>}
      </label>
      <button
        onClick={toggleDropdown}
        type="button"
        disabled={data.length === 0}
        className={`${styles.multidropdownButton} ${
          isOpen && styles.multidropdownButton_active
        }`}
      >
        <span className={`${!state && styles.placeholder}`}>
          {state ? state : placeholder}
        </span>
        <img
          src={arrow}
          className={`${styles.arrow} ${isOpen && styles.arrow_open}`}
          alt="Стрелка выпадающего списка"
        />
        <input
          type="text"
          className="visually-hidden"
          value={state ?? undefined}
          required={required}
          tabIndex={-1}
        />
      </button>
      {isOpen && (
        <ul className={styles.multidropdownMenu}>
          {data.map((option) => (
            <li
              className={styles.multidropdownItem}
              key={option.id}
              onClick={() => {
                handlerClick(option);
              }}
            >
              {option.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
